import {
    UrlAction,
    UrlActionTypes,
} from "../interfaces/context/searchContextInterfaces";

export const urlReducer = (state: string, action: UrlAction) => {
    switch (action.type) {
    case UrlActionTypes.updateUrl: {
        return action.payload;
    }
    default: {
        return state;
    }
    }
};
